/**
 * 判断是否为空对象
 *
 * @param {Object} obj 传入对象
 * @return {boolean} 返回值
 */
var isEmptyObj = function (obj) {
    if (obj === void 0) { obj = {}; }
    return !Object.keys(obj).length;
};

export { isEmptyObj as i };
//# sourceMappingURL=isEmptyObj-9e2fc2f5.js.map
